import {PageFragment, PageFragmentProps, PageFragmentState} from "@/shared/PageFragment";
import {FormGenContainer, FormGenContainerMode} from "@/shared/FormGenContainer";
import {LabelerTask} from "@/fyneai-shared/types";
import React from "react";
import {StyledBoxColumn} from "../../../../shared/StyledComponents";
import {PD_XLG2} from "../../../../shared/dimens";

export type TaskOverviewFragmentProps = PageFragmentProps & {
  task: LabelerTask,
}

export class TaskOverviewFragment extends PageFragment<TaskOverviewFragmentProps, PageFragmentState> {

  protected getTitle(): string | null | undefined {
    return "Overview";
  }

  renderContent(): React.ReactElement {
    return <StyledBoxColumn style={{padding: PD_XLG2}}>
      <FormGenContainer
        mode={FormGenContainerMode.READ}
        content={this.props.task}/>
    </StyledBoxColumn>;
  }
}
